@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- Classy -->
@if (layout === 'classy') {
    <classy-layout></classy-layout>
}
